import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout"
import { usePageMeta } from "shared/mechanics/page-meta";
import { SubscriptionCompletePageLayout } from "./layout"

export const SubscriptionCompletePage = () => {
	usePageMeta({
		title: 'Вы Инвестор+',
		description: 'Успешное получение подписки',
		keyWords: ['цена', 'оплата', 'подписки', 'paywall'],
		canonicalPath: 'subscription/complete' });
		
	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<SubscriptionCompletePageLayout />
		</SiteLayoutComponent>
	);
}